import React from "react";

import Footer from 'components/home_footer'
import BannerFourText from "components/banner4_text";

import styles from './banner4_page.module.css'

import second from 'static/second.jpg'

import Nabar from "components/Nabar";
import MainSearch from "components/main_search";

const BannerFourPage = () => {

  
  return ( 
    <div>
      <Nabar/>
      <div className='hero-banner magic-ball home'>
        <div className='main-banner'>
          <img src={second} alt='front pic' />
          <MainSearch banner={true}/>
        </div>
      </div>

        <BannerFourText/>

      <div className={styles.footer}>
          <Footer/>
      </div> 
    </div>
  );
}

export default BannerFourPage;